<template>
  <!-- Deposit -->
  <div id="Deposit">
    <!-- 内容区域 -->

    <el-container style="width: 100%;height: 100%; background: #fff;">
      <el-header>
        <mu-appbar class="is-full-width" v-bind:title="titleStr" color="#fff" textColor="#303644" z-depth=0>
          <mu-button @click="leftBtn" icon slot="left">
            <mu-icon value="arrow_back"></mu-icon>
          </mu-button>
        </mu-appbar>
      </el-header>

      <el-main>
        <el-row class="qrCodeRow">
          <div id="qrCode" ref="qrCodeDiv"></div>
        </el-row>

        <el-row class="erow">
          <el-col><p id="codeText" style="width: 100%;text-align: center;">xxxxxxxxxxxxxxx</p></el-col>
        </el-row>

          <el-row class="erow">
            <el-button @click="submit($event)" class="CopyBtn" fill>Copy the above address</el-button>
          </el-row>

          <el-row class="erow">
            <!-- <el-col> -->
              <p style="width: 100%;margin:0; padding:0;">
            <font style="font-weight: bold;">Matters needing attention</font><br/><br/>
            <font style="word-break: break-all;font-size: 0.625rem;">1. Do not recnarge any non-{{this.$route.query.Name}} assets to the above add ess, otherwise the assets will not be recovered
            </font><br/><br/>
            <font style="word-break: break-all;font-size: 0.625rem;">2. After recharging, it needs the confirmation of the whgle network node and arrives at the accouht after one network confirmation.
            </font><br/><br/>
            <font style="word-break: break-all;font-size: 0.625rem;">3. Minimum recharge amount: 0.001 {{this.$route.query.Name}}, less than the minimum amount of recharge will not be charged.
            </font><br/><br/>
            <font style="word-break: break-all;font-size: 0.625rem;">4. The replenishment address will not change, and the replenishment can be repeated.
            </font>
            </p>
            <!-- </el-col> -->
          </el-row>
      </el-main>
      <!-- <el-footer>
          <BottomNav style="height: 100%; width: 100%;"></BottomNav>
          </el-footer> -->
    </el-container>


  </div>
</template>

<script>
  import $ from 'jquery'
  import QRCode from 'qrcodejs2';
  import Clipboard from 'clipboard'
  import {
    lStorage,
    sStorage
  } from "@Comm/js/Storage.js"
  export default {
    data() {
      return {
        titleStr: 'Deposit',
        QRCodeText:""
      }
    },
    mounted() {
      // console.log(this.$route.query.Name);
      // this.$nextTick(function() {
        var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
        // console.log(UserInfo.bTC_address);
        // this.QRCodeText = "13KfhCLnNoBo6EbCSMpp6ihriQGz2Jbynx";
        // console.log(this.$route.query.Name);
        // console.log(UserInfo.uSDT_address);
        if (this.$route.query.Name=="BTC"){
        this.bindQRCode(UserInfo.bTC_address);
        $("#codeText").html(UserInfo.bTC_address);
        }else if (this.$route.query.Name=="ETH"){
        this.bindQRCode(UserInfo.eTH_address);
        $("#codeText").html(UserInfo.eTH_address);
        }else {
        this.bindQRCode(UserInfo.uSDT_address);
        $("#codeText").html(UserInfo.uSDT_address);
        }
      // })
    },
    methods: {
      leftBtn() {
        this.$router.go(-1); //返回上一层
      },
      bindQRCode: function(qcode) {
        new QRCode(this.$refs.qrCodeDiv, {
          text: qcode,
          width: 150,
          height: 150,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        })
      },
      submit (e) {
              console.log("---------");
              // console.log(this.QRCodeText);
              // console.log($("#codeText").append(item));
              // console.log($("#codeText"));
      //从属性里复制
          // var btn = document.getElementById('codeText');
          // var clipboard = new Clipboard($("#codeText").text());//实例化
          var clipboard = new Clipboard(e.target, {
                  text: () => $("#codeText").text()
                });
          clipboard.on('success', () => {
              this.$message({
                message: 'Copy success',
                type: 'success'
              });
                  // clipboardError();
                  // 释放内存
                  clipboard.destroy()
              });
              clipboard.on('error', () => {
              this.$message.error('Copy error');
                  // 不支持复制
                  // clipboardError();
                  // 释放内存
                  clipboard.destroy()
              });
              // 解决第一次点击不生效的问题，如果没有，第一次点击会不生效
              clipboard.onClick(e);
            }
    },
    components: {
    }
  };
</script>

<style>
  @import '../../../../Comm/css/CommCSS.css';
  /* #Deposit .mu-appbar .mu-appbar-title {
     text-align: center;
   } */
   #Deposit .is-full-width {
     width: 100%;
     height: 100%;
   }

   #Deposit .content {
     flex: 1
   }

   #Deposit .el-header {
    padding: 0 0px;
   }

   #Deposit .el-main {
       padding: 0px;
   }

   #Deposit #qrCode {
         display: flex;
         margin: 0 auto;
   }

   #Deposit .qrCodeRow {
     margin: 0 auto; /*水平居中*/
     margin-top: 1.25rem;
     display: flex;
     width:80%;
   }

   #Deposit img {
     margin: 0 auto; /*水平居中*/
    /* display: inline-block;
     position: relative; */
       width: 150px;
       height: 150px;
       /* background-color: #fff; //设置白色背景色 */
       /* padding: 6px; // 利用padding的特性，挤出白边 */
   }

   #Deposit .erow{
    margin: 0 auto; /*水平居中*/
    margin-top: 1.25rem;
    /* display: flex; */
    width:80%;
   }

  #Deposit .CopyBtn {
    margin: 0 auto; /*水平居中 */
    display: flex;
    /* padding: 30px; */
    font-size: 15px;
    color: #FFFFFF;
    background-color: #303644;
    border-radius: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Extract/Deposit/Deposit.vue